import React from 'react';

import { ModalContextType } from './types';

export const ModalContext = React.createContext<ModalContextType>({} as any);
